import { Link } from "react-router-dom";

const IndustryCards = ({ industryCardData }) => {
  const {
    industryCardTitle,
    industryCardContent,
    industryCardImg,
    industryCardLink,
  } = industryCardData;

  return (
    <div className="landing__industry-card">
      <div className="landing__industry-card-left">
        <h6>{industryCardTitle}</h6>
        <p>{industryCardContent}</p>
      </div>
      <div className="landing__industry-card-right">
        <div className="industry-card-img-wrap">
          <img
            src={industryCardImg}
            alt="World's No.1 Blockchain Development Company"
            loading="lazy"
          />
        </div>
        <Link to={industryCardLink} className="industry-card-link">
          <span>
            <i className="bi bi-arrow-up-right"></i>
          </span>
        </Link>
      </div>
    </div>
  );
};

export default IndustryCards;
